import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './tenantSettingsPage.intl.json';

export const useTenantSettingsPageIntl = () => useIntlModule(messages);
